import { render } from "./CodeChoosePropertyTag.vue?vue&type=template&id=646809ec&scoped=true&ts=true"
import script from "./CodeChoosePropertyTag.vue?vue&type=script&lang=ts"
export * from "./CodeChoosePropertyTag.vue?vue&type=script&lang=ts"

import "./CodeChoosePropertyTag.vue?vue&type=style&index=0&id=646809ec&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646809ec"]])

export default __exports__